import React, { useEffect, useState } from 'react'
import { archiveBannerById, archiveSkill, getBannerList, getSkillList } from '../../actions/utilitiesAction'
import BannerList from '../../component/Banner/BannerList'
import constant from '../../constant'
import queryString from 'query-string'
import { useLocation } from "react-router-dom";

const BannerLists = () => {

    const [List, setList] = useState(null)
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [keyword, setKeyword] = useState('')
    const [showLoader, setShowLoader] = useState(false)
    const location = useLocation()


    useEffect(() => {
        const qParams = queryString.parse(location.search)
        getBannersLists(qParams?.p ? qParams?.p : qParams?.pageno ? qParams.pageno : currentPage);
        document.title = constant.title.SkillList
    }, [currentPage])

    const getBannersLists = (page) => {
        setShowLoader(true)
        getBannerList({ KEYWORD: keyword, page: page }).then((res) => {
            
            if (res.status) {
                setShowLoader(false)
                setList(res.result.list)
                setCount(res.result.count.total)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    const updateStatus = (model) => {
        archiveBannerById(model).then((res) => {
            if (res.status) {
                getBannersLists(currentPage)
            }
            else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }
    return (
        <React.Fragment>
            <BannerList
                List={List}
                setList={setList}
                updateStatus={updateStatus}
                getBannersLists={(page) => { getBannersLists(page) }}
                count={count}
                setPage={setCurrentPage}
                setKeyword={setKeyword}
                showLoader={showLoader}
                cpage={currentPage}
            />
        </React.Fragment>
    )
}
export default BannerLists